import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from './app.reducers';
import { AuthService } from './shared/auth/services';
import { AnalyticsService } from './shared/analytics';
import {
  LoadComponentInformationSourcesLookupAction,
  LoadComponentTypesLookupAction,
  LoadUnitsOfMeasureLookupAction
} from './internal/component/component-store';
import {
  LoadPropertyTypesAction,
  LoadWorkspaceUserPropertiesAction
} from './internal/property/property-store/property.actions';
import { LoadUserProfileAction } from './internal/user/redux/user.actions';
import { LoadCurrentUserWorkspacesAction, LoadWorkspaceSettingsAction } from './internal/workspace/workspace-store';
import { SubSink } from 'subsink';
import { Intercom } from './ng-intercom';
import { AssetLibraryActions } from './internal/asset-library/store/actions/asset-library.actions';


@Component({
  selector: 'sp-app',
  template: `<router-outlet></router-outlet>
  <div toastContainer></div>`,
  standalone: false
})

export class AppComponent implements OnInit, OnDestroy {

  private subs = new SubSink();

  public constructor(
    public router: Router,
    public intercom: Intercom,
    private store: Store<AppState>,
    private authService: AuthService,
    private analyticsService: AnalyticsService) {

  }

  ngOnInit() {

    this.store.dispatch(new LoadUnitsOfMeasureLookupAction());
    this.store.dispatch(new LoadComponentInformationSourcesLookupAction());
    this.store.dispatch(new LoadComponentTypesLookupAction());
    this.store.dispatch(new LoadPropertyTypesAction());

    if (this.authService.isAuthorized()) {
      this.store.dispatch(new LoadWorkspaceSettingsAction());
      this.store.dispatch(new LoadUserProfileAction());
      this.store.dispatch(new LoadWorkspaceUserPropertiesAction());
      this.store.dispatch(AssetLibraryActions.loadCategoriesWithComponents());
      this.store.dispatch(new LoadCurrentUserWorkspacesAction());
    }

    // the analyticsServices is a root item (singleton), so it will be created once it is referenced.
    // calling setup here to ensure it is created and the subscribe events for page views are enabled.
    this.analyticsService.setup();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
